import { useState } from "react";
import { useResidueActions } from "./useResidueActions";

type ConfirmActionType = {
    type: "delete";
    residueId: string;
    residueName: string;
};

export const useConfirmationDialog = (onSuccess: () => void) => {
    const [isOpen, setIsOpen] = useState(false);
    const [confirmAction, setConfirmAction] = useState<ConfirmActionType | null>(null);
    const { handleDelete, isLoading } = useResidueActions();

    const openDialog = (action: ConfirmActionType) => {
        setConfirmAction(action);
        setIsOpen(true);
    };

    const closeDialog = () => {
        setIsOpen(false);
        setTimeout(() => setConfirmAction(null), 200);
    };

    const handleConfirm = async () => {
        if (!confirmAction) return;

        try {
            if (confirmAction.type === "delete") {
                await handleDelete(confirmAction.residueId);
            }
            onSuccess();
            closeDialog();
        } catch (error) {
            console.error(`Error ${confirmAction.type} residue:`, error);
        }
    };

    return {
        isOpen,
        confirmAction,
        isLoading,
        openDialog,
        closeDialog,
        handleConfirm,
    };
}; 